import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PolicyClient } from '@benefitsui/app/api/benefits-clients';
import { PolicyContext } from './policy-context.types';
import { PolicyTokensAccessor } from '@benefitsui/app/lib/policy/policy-token/policy-token-accessor.service';
import { PolicyService } from '../policy/policy.service';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';

@Injectable({ providedIn: 'root' })
export class PolicyContextResolver {
  constructor(
    private policyClient: PolicyClient,
    private policyTokensAccessor: PolicyTokensAccessor,
    private policyService: PolicyService
  ) {
    this.token = this.policyTokensAccessor.get().value.join(',');
  }

  // :  Data members
  private token: string;

  resolve(): Observable<PolicyContext> {
    const result = this.policyClient.overview().pipe(
      map((rsp) => {
        if (rsp.data?.policyDetails === null) {
          return {
            groupId: '0',
            groupNumber: '0',
            policyId: '0',
            policyIds: [],
            policyToken: this.token,
            policyHolder: Defaults.stringEmpty
          };
        }
        const context: PolicyContext = {
          groupId: rsp.data?.policyDetails?.groupId ?? Defaults.stringEmpty,
          groupNumber: rsp.data?.groupNumber ?? Defaults.stringEmpty,
          policyId: rsp.data?.policyDetails?.policyId ?? Defaults.stringEmpty,
          policyIds: rsp.data?.policyIds ?? [],
          policyToken: rsp.data?.policyToken ?? this.token,
          policyHolder: rsp.data?.policyDetails?.policyHolder ?? Defaults.stringEmpty
        };
        this.policyService.setgroupId(context?.groupId ?? Defaults.stringEmpty);
        this.policyService.setgroupNumber(context?.groupNumber ?? Defaults.stringEmpty);
        this.policyService.setpolicyId(context?.policyId ?? Defaults.stringEmpty);
        this.policyService.setpolicyIds(context?.policyIds ?? Defaults.stringEmpty);
        this.policyService.setpolicyName(context?.policyHolder ?? Defaults.stringEmpty);
        return context;
      })
    );

    return result;
  }
}
